import AdminPayPage from "./AdminPayPage";

export default AdminPayPage;
